import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';
import { CommonKey, LeagueSeason } from '../../../types/api';

type SeasonInput = {
    leagueId: number;
};

const fetchSeasons = async ({
    leagueId,
}: SeasonInput): Promise<LeagueSeason[]> => {
    if (!leagueId) return [];
    const result: LeagueSeason[] = await sportsApi
        .url(`/league-seasons`)
        .query({ leagueId })
        .get()
        .json();
    return result;
};

const useSeasons = ({ leagueId }: SeasonInput) =>
    useQuery({
        queryKey: [CommonKey.InVenueSeasons, leagueId],
        queryFn: (): Promise<LeagueSeason[]> => fetchSeasons({ leagueId }),
    });

export default useSeasons;
